import { EMPTY_ENCODING } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { DEFAULT_CHART_FORMAT } from '@mode/shared/util-js';
import { Store } from '@ngrx/store';
import { TypedAction } from '@ngrx/store/src/models';
import { Observable, pipe } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { selectChartState } from '../chart/chart.selectors';
import { DomainAppState } from '../charts-domain.types';

export function withLatestSnapshot<A extends TypedAction<T1> & Record<P, string>, T1 extends string, P extends keyof A>(
  store: Store<DomainAppState>,
  tokenProp: P
) {
  return pipe<
    Observable<A>,
    Observable<{ action: A; token: string; snapshot: ChartTypes.ChartSnapshot; queryToken: string }>
  >(
    withLatestFrom(store.select(selectChartState), (action, charts) => ({
      action,
      token: action[tokenProp],
      snapshot: {
        encoding: charts.encodings.get(action[tokenProp]) || EMPTY_ENCODING,
        chartType: charts.chartTypes.get(action[tokenProp]) || 'bar',
        title: charts.titles.get(action[tokenProp]) || '',
        description: charts.descriptions.get(action[tokenProp]) || '',
        caption: charts.captions.get(action[tokenProp]) || ChartTypes.EMPTY_CAPTION,
        format: charts.formats.get(action[tokenProp]) || DEFAULT_CHART_FORMAT,
        fieldFormats: charts.fieldFormats.get(action[tokenProp]) || {},
        fieldColors: charts.fieldColors.get(action[tokenProp]) || {},
        colorPaletteToken: charts.colorPaletteTokens.get(action[tokenProp]) || '',
        facetSizes: charts.facetSizes.get(action[tokenProp]) || {},
        isAutoUpdateDisabled: charts.isAutoUpdateDisabled.get(action[tokenProp]) || false,
      },
      queryToken: charts.queryTokens.get(action[tokenProp]) || '',
    }))
  );
}
